import React, { useState } from "react";
import styled from "@emotion/styled";
import PropTypes from "prop-types";
import { Swiper, SwiperSlide } from "swiper/react";
import { A11y, Navigation } from "swiper";
import Slide from "./Slide";
import SliderArrows from "./SliderArrows";
import Lightbox from "../Lightbox/Lightbox";
import disablePageScroll from "../../actions/disablePageScroll";

// Import Swiper styles
import "swiper/css";

const Slider = ({ slidesJson }) => {
	const [slides] = useState(JSON.parse(slidesJson));
	const [lightboxIndex, setLightboxIndex] = useState(null);

	const handleClick = (index) => {
		setLightboxIndex(index);
	};

	const renderSlides = () => {
		if (!slides || slides.length === 0) return;
		return slides.map((slide, index) => {
			return (
				<SwiperSlide key={index}>
					<Slide slide={slide} handleClick={handleClick} index={index} />
				</SwiperSlide>
			);
		});
	};

	disablePageScroll(lightboxIndex !== null);

	return (
		<Wrapper>
			<Swiper
				modules={[A11y, Navigation]}
				navigation={{
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				}}
				spaceBetween={32}
				slidesPerView={"auto"}
			>
				<SliderArrows />
				{renderSlides()}
			</Swiper>
			<Lightbox
				show={Number.isInteger(lightboxIndex)}
				images={slides}
				activeIndex={lightboxIndex}
				handleClose={() => handleClick(null)}
			/>
		</Wrapper>
	);
};

Slider.propTypes = {
	slidesJson: PropTypes.string,
};

export default Slider;

const Wrapper = styled.div`
	.swiper {
		display: flex;
		flex-direction: column-reverse;
	}
	.swiper-wrapper {
		padding-top: 2.5rem;
		width: calc(100vw - 48px);
	}

	.swiper-slide {
		width: auto;

		&:hover {
			cursor: grab;
		}
	}
`;
